import styles from "./Testimonial.module.css";
const Testimonial = (props) => {
  const { data } = props;
  return (
    <section
      className={
        styles[
          "main-section__5__testimonials__testimonial"
        ]
      }
    >
      <div
        className={
          styles[
            "main-section__5__testimonials__testimonial__header"
          ]
        }
      >
        <div
          style={{
            backgroundImage: `url(${data.image})`,
          }}
          className={
            styles[
              "main-section__5__testimonials__testimonial__header__image"
            ]
          }
        ></div>
        <div
          className={
            styles[
              "main-section__5__testimonials__testimonial__header__text"
            ]
          }
        >
          <h3>{data.name}</h3>
          <h4>{data.location}</h4>
        </div>
      </div>
      <p>{data.about}</p>
    </section>
  );
};

export default Testimonial;
